module.exports = __webpack_public_path__ + "static/img/culture1.8da533c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture1.png
// module id = oypK
// module chunks = 1